module.exports = __webpack_public_path__ + "media/7.f3f6971e.mp3";